// components/ContentSection.tsx
import React from "react";
import { FormattedMessage } from "react-intl";

interface ContentSectionProps {
  contentId: string;
  imageSrcs: string[];
  values?: Record<string, React.ReactNode>;
}

export const ContentSection: React.FC<ContentSectionProps> = ({
  contentId,
  imageSrcs,
  values,
}) => {
  return (
    <div>
      <p className="mt-10">
        <FormattedMessage id={contentId} values={values} />
      </p>
      {imageSrcs.map((imageSrc, index) => (
        <img
          key={index}
          src={imageSrc}
          alt=""
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-white10 mt-6"
        />
      ))}
    </div>
  );
};
